import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';
// material
import { Container, Grid, } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, InputAdornment, Button, } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = "VEHICLEMASTER"

export default function VehicleMasterAddEdit(props) {
  const [date, setDate] = useState(new Date());
  const [value, setValue] = useState(null);
  const [maxValue, setMaxValue] = useState(new Date());
  const [minValue, setMinValue] = useState(new Date('1990-01-01'));
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [capacityList, setCapacityList] = useState([]);
  const [fueltypeList, setFueltypeList] = useState([]);
  const [vehicleOwnershipList, setVehicleOwnershipList] = useState([]);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: '0',
    vehicleCode: '',
    dateID: date.toISOString().split('T')[0],
    vehicleRegNumber: '',
    capacity: '',
    size: 0,
    brand: 0,
    fuelType: 0,
    vehicleOwnership: 0,
    paymentType: 0,
    isActive: true,
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageName: "Add Vehicle"
  });


  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
    vehicleCode: Yup.string().required('Vehicle Code required'),
    vehicleRegNumber: Yup.string().matches(/^[^\s]*$/g, 'Can not enter space').required('Vehicle Registration Number required'),
    dateID: Yup.date().required('Date of Cargills Registration required'),
    size: Yup.number().min(1, 'Please Select Size').required('Size required'),
    capacity: Yup.number().min(0, 'Please Select Capacity').required('Capacity required'),
    brand: Yup.number().notRequired(),
    fuelType: Yup.number().min(1, 'Please Select Fuel Type').required('Fuel Type required'),
    vehicleOwnership: Yup.number().min(1, 'Please Select Vehicle Ownership').required('Vehicle Ownership required'),
    paymentType: Yup.number().min(1, 'Please Select Payment Type').required('Payment Type required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      vehicleCode: formData.vehicleCode,
      vehicleRegNumber: formData.vehicleRegNumber,
      capacity: formData.capacity,
      dateID: formData.dateID,
      size: formData.size,
      brand: formData.brand,
      fuelType: formData.fuelType,
      vehicleOwnership: formData.vehicleOwnership,
      paymentType: formData.paymentType,
      isActive: formData.isActive,
    },

    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  const { vehicleID } = useParams();
  let decrypted = 0;

  useEffect(() => {
    decrypted = AESDecryptionParam(vehicleID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        editingID: parseInt(decrypted),
        pageName: "Edit Vehicle"
      })
    }
    else {
      trackPromise(GetLastVehicleCode())
    }
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);


  useEffect(() => {
    if (pageProps.editingID > 0) {
      trackPromise(setForEdit(pageProps.editingID))
    }
  }, [pageProps.editingID]);

  useEffect(() => {
    if (pageProps.isEdit != true) {
      if (formik.values.groupID != 0) {
        trackPromise(GetLastVehicleCode())
      }
    }
  }, [formik.values.groupID]);


  useEffect(() => {
    trackPromise(GetAllBrands());
  }, []);

  useEffect(() => {
    trackPromise(GetAllCapacities());
  }, []);

  useEffect(() => {
    trackPromise(GetAllFuelTypes());
  }, []);

  useEffect(() => {
    trackPromise(GetAllVehicleOwnerships());
  }, []);

  useEffect(() => {
    trackPromise(GetAllPaymentTypes());
  }, []);
  
  async function setForEdit(id) {
    var data = await Services.GetVehicleDetailsByVehicleID(id);
    setValues({
      ...values,
      groupID: data.groupID,
      operationEntityID: data.operationEntityID,
      dateID: data.dateOfRegistration.split('T')[0],
      vehicleCode: data.vehicleCode,
      vehicleRegNumber: data.vehicleNumber,
      capacity: data.capacity == null ? '' : data.capacity,
      size: data.size,
      brand: data.brand,
      fuelType: data.fuelType,
      vehicleOwnership: data.vehicleOwnershipTypeID,
      paymentType: data.vehiclePaymentTypeID,
      isActive: data.isActive,
    })
    setValue(data.yearOfManufacture)
  }

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITVEHICLEMASTER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    trackPromise(GetAllGroups());

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })

  }

  async function GetLastVehicleCode() {
    var res = await Services.GetLastVehicleCode();
    if (res.length != 0) {
      var substring = res[0].vehicleCode.slice(2);
      var newRes = parseInt(substring) + 1
      setValues({
        ...values,
        vehicleCode: 'VC' + newRes.toString()
      })
    }
    else {
      setValues({
        ...values,
        vehicleCode: 'VC10001'
      })
    }
  }

  async function GetAllGroups() {
    var res = await Services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await Services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function SubmitForm(data) {
    if (pageProps.isEdit == false) {
      let saveModel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        vehicleCode: data.vehicleCode,
        vehicleNumber: data.vehicleRegNumber,
        capacity: data.capacity == null ? 0 : data.capacity,
        vehicleTagNumber: data.vehicleRegNumber + '-' + data.vehicleCode,
        dateID: data.dateID,
        size: data.size,
        brand: data.brand,
        fuelType: data.fuelType,
        vehicleOwnership: data.vehicleOwnership,
        paymentType: data.paymentType,
        isActive: data.isActive,
        yearOfManufacture: value == null ? "" : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.SaveVehicle(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/VehicleMaster');
        }, 800);
      } else {
        toast.error(res.message);
      }
    }
    else {
      let saveModel = {
        vehicleID: parseInt(pageProps.editingID),
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        vehicleNumber: data.vehicleRegNumber,
        capacity: data.capacity == null ? 0 : data.capacity,
        dateID: data.dateID,
        size: data.size,
        brand: data.brand,
        fuelType: data.fuelType,
        vehicleOwnership: data.vehicleOwnership,
        paymentType: data.paymentType,
        isActive: data.isActive,
        yearOfManufacture: value == null ? "" : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.UpdateVehicle(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/VehicleMaster');
        }, 800);
      } else {
        toast.error(res.message);
      }
    }
  }

  async function clearAll() {
    setValues({
      ...values,
      groupID: 0,
      operationEntityID: '0',
      vehicleCode: '',
      dateID: date.toISOString().split('T')[0],
      vehicleRegNumber: '',
      capacity: 0,
      size: 0,
      brand: 0,
      fuelType: 0,
      vehicleOwnership: 0,
      paymentType: 0,
      isActive: true,
    })
  }

  async function GetAllBrands() {
    var res = await Services.GetBrand();
    if (res != null) {
      setBrandList(res);
    }
  }

  async function GetAllCapacities() {
    var res = await Services.GetCapacity();
    if (res != null) {
      setCapacityList(res);
    }
  }

  async function GetAllFuelTypes() {
    var res = await Services.GetFuelType();
    if (res != null) {
      setFueltypeList(res);
    }
  }

  async function GetAllVehicleOwnerships() {
    var res = await Services.GetVehicleOwnership();
    if (res != null) {
      setVehicleOwnershipList(res);
    }
  }

  async function GetAllPaymentTypes() {
    var res = await Services.GetPaymentType();
    if (res != null) {
      setPaymentTypeList(res);
    }
  }
 

  const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <Page title="Add Vehicle  |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/dashboard/VehicleMaster'}
            btname="Back"
            pageName={pageProps.pageName}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 1 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    size="small"
                    label="Vehicle Code"
                    value={formik.values.vehicleCode}
                    onChange={formik.handleChange}
                    {...getFieldProps('vehicleCode')}
                    error={Boolean(touched.vehicleCode && errors.vehicleCode)}
                    helperText={touched.vehicleCode && errors.vehicleCode}
                    InputProps={{
                      readOnly: true
                    }}
                  />

                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Vehicle Registration Number *"
                    value={formik.values.vehicleRegNumber}
                    onChange={formik.handleChange}
                    {...getFieldProps('vehicleRegNumber')}
                    error={Boolean(touched.vehicleRegNumber && errors.vehicleRegNumber)}
                    helperText={touched.vehicleRegNumber && errors.vehicleRegNumber}
                  />
                  <TextField
                    fullWidth
                    id="outlined-start-adornment"
                    size="small"
                    label="Date of Cargills Registration *"
                    type="Date"
                    value={formik.values.dateID}
                    onChange={formik.handleChange}
                    {...getFieldProps('dateID')}
                    error={Boolean(touched.dateID && errors.dateID)}
                    helperText={touched.dateID && errors.dateID}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                  >
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Size *"
                    value={formik.values.size}
                    onChange={formik.handleChange}
                    {...getFieldProps('size')}
                    error={Boolean(touched.size && errors.size)}
                    helperText={touched.size && errors.size}
                  >

<                   MenuItem key={0} value={0}>Select Size</MenuItem>
                    {capacityList.map((option) => (
                      <MenuItem key={option.capacityID} value={option.capacityID}>
                        {option.capacity}
                      </MenuItem> 
                    ))}

                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Capacity *"
                  value={formik.values.capacity}
                  onChange={(event) => {
                    let value = event.target.value;

                    if (value === "") {
                      formik.setFieldValue("capacity", value);
                      return;
                    }
                    if (/^\d+(\.\d{0,2})?$/.test(value)) {
                      formik.setFieldValue("capacity", value);
                    }
                  }}
                  {...getFieldProps("capacity")}
                  error={Boolean(touched.capacity && errors.capacity)}
                  helperText={touched.capacity && errors.capacity}
                  InputProps={{
                    inputProps: { min: 0, step: 0.01 },
                  }}
                  onKeyDown={(e) => {
                    const { value } = e.target;
                    if (
                      ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                    ) {
                      return;
                    }

                    if (!/^\d|\.$/.test(e.key)) {
                      e.preventDefault();
                      return;
                    }

                    if (e.key === "." && value.includes(".")) {
                      e.preventDefault();
                      return;
                    }

                    if (value.includes(".") && value.split(".")[1].length >= 2) {
                      e.preventDefault();
                    }
                  }}
                />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      size="small"
                      label="Year of Manufacture"
                      openTo="year"
                      views={['year']}
                      value={value}
                      minDate={minValue}
                      maxDate={maxValue}
                      onChange={(newValue) => {
                        setValue(newValue);
                      }}
                      renderInput={(params) =>
                        <TextField
                          fullWidth
                          size="small"
                          {...params}
                        />}
                    />
                  </LocalizationProvider>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fuel Type *"
                    value={formik.values.fuelType}
                    onChange={formik.handleChange}
                    {...getFieldProps('fuelType')}
                    error={Boolean(touched.fuelType && errors.fuelType)}
                    helperText={touched.fuelType && errors.fuelType}
                  >

                    <MenuItem key={0} value={0}>Select Fuel Type</MenuItem>
                    {fueltypeList.map((option) => (
                      <MenuItem key={option.fuelTypeID} value={option.fuelTypeID}>
                        {option.fuelType}
                      </MenuItem> 
                    ))}
                    
                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Brand"
                    value={formik.values.brand}
                    onChange={formik.handleChange}
                    {...getFieldProps('brand')}
                    error={Boolean(touched.brand && errors.brand)}
                    helperText={touched.brand && errors.brand}
                  >

                    <MenuItem key={0} value={0}>Select Brand</MenuItem>
                    {brandList.map((option) => (
                      <MenuItem key={option.brandID} value={option.brandID}>
                        {option.brandName}
                      </MenuItem> 
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Vehicle Ownership *"
                    value={formik.values.vehicleOwnership}
                    onChange={formik.handleChange}
                    {...getFieldProps('vehicleOwnership')}
                    error={Boolean(touched.vehicleOwnership && errors.vehicleOwnership)}
                    helperText={touched.vehicleOwnership && errors.vehicleOwnership}
                  >
                    <MenuItem key={0} value={0}>Select Vehicle Ownership</MenuItem>
                    {vehicleOwnershipList.map((option) => (
                      <MenuItem key={option.vehicleOwnershipTypeID} value={option.vehicleOwnershipTypeID}>
                        {option.vehicleOwnershipTypeName }
                      </MenuItem> 
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Payment Type *"
                    value={formik.values.paymentType}
                    onChange={formik.handleChange}
                    {...getFieldProps('paymentType')}
                    error={Boolean(touched.paymentType && errors.paymentType)}
                    helperText={touched.paymentType && errors.paymentType}
                  >
                    <MenuItem key={0} value={0}>Select Payment Type</MenuItem>
                    {paymentTypeList.map((option) => (
                      <MenuItem key={option.vehiclePaymentTypeID } value={option.vehiclePaymentTypeID }>
                        {option.vehiclePaymentTypeName}
                      </MenuItem> 
                    ))}
                  </TextField>
              </Stack>
                </Stack>
              <br />
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormControlLabel
                  control={
                    <Switch
                      value={formik.values.isActive}
                      checked={formik.values.isActive}
                      {...getFieldProps('isActive')}
                      onClick={formik.handleChange}
                      color="error"
                      name="isActive"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />}
                  label="Is Active"
                />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <Button
                  type="button"
                  color='error'
                  variant="outlined"
                  disabled={pageProps.editingID > 0}
                  onClick={() => clearAll()}
                > Clear</Button>
                <Button type="submit" color="secondary" variant="outlined">
                  {pageProps.submitButtonName}
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page>
    </>
  );
}
